export default __webpack_public_path__ + "static/media/another_motive.e0072044.svg";